(function($, undefined) {
	
	'use strict';
	
	var showMoreBrands = function() {
		$(this).fadeOut();
		var count = 0;

		$('.portfolio-brands-ctn').find('.portfolio-one-brand.hide').each(function() {
			var t = $(this);
			count++;

			setTimeout(function() {
				t.fadeIn();
			}, count * 400);
		});
	};
	
	var init = function () {
		$('.portfolio-show-more-brands-btn').click(showMoreBrands);
	};
	
	$(window).ready(function () {
		init();
	});
	
})(jQuery);
